import * as React from "react";

import { JSX } from "react/jsx-runtime";

const AddCircle = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="add-circle">
      <path
        id="Vector"
        d="M12.5 8V16M16.5 12H8.5"
        stroke="#6C757D"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12Z"
        stroke="#6C757D"
        strokeWidth={1.5}
      />
    </g>
  </svg>
);
export default AddCircle;
